import { FaCalendar, FaClock } from "react-icons/fa6";
import { cn } from "@/lib/utils";
import useCurrentDate from "@/hooks/useCurrentDate";
import useMapStore from "@/store/mapStore";

function DateTime() {
  const mobileMode = useMapStore((state) => state.mobileMode);
  const kioskMode = useMapStore((state) => state.kioskMode);
  const verticalKioskMode = useMapStore((state) => state.verticalKioskMode);
  const kioskScaling = useMapStore((state) => state.kioskScaling);
  const { formatDate, formatTime } = useCurrentDate();

  if (mobileMode || !kioskMode) {
    return null;
  }

  return (
    <div
      className={cn(
        "absolute top-[43px] z-[6] flex min-w-60 cursor-pointer items-center justify-center rounded-xl bg-white px-4 py-2 text-lg text-primary shadow-[0px_1px_6px_3px_rgba(0,0,0,0.5)] group-data-[dir=ltr]:right-[208px] group-data-[dir=rtl]:left-[208px] kiosk:text-2xl",
        verticalKioskMode &&
          "kiosk:min-w-[460px] kiosk:group-data-[dir=ltr]:left-10 kiosk:group-data-[dir=ltr]:right-auto kiosk:group-data-[dir=rtl]:left-auto kiosk:group-data-[dir=rtl]:right-10",
        !kioskScaling &&
          "kiosk:top-[80px] kiosk:scale-[2] kiosk:group-data-[dir=ltr]:origin-bottom-left kiosk:group-data-[dir=rtl]:origin-bottom-right",
      )}
    >
      <FaCalendar className="inline-block group-data-[dir=ltr]:mr-2 group-data-[dir=rtl]:ml-2" />
      <span className="text-xs text-black kiosk:text-lg">{formatDate()}</span>
      <FaClock className="mx-2 inline-block kiosk:group-data-[dir=ltr]:ml-8 kiosk:group-data-[dir=rtl]:mr-8" />
      <span className="text-xs text-black kiosk:text-lg">{formatTime()}</span>
    </div>
  );
}

export default DateTime;
